import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import Leftmenu from "../../components/Leftmenu";
import Rightmenu from "../../components/Rightmenu";
import Pagination from "../../components/Pagination";
import { Link, useOutletContext, useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";

function AdminPendingAccounts() {
  const { user, token } = useOutletContext();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const initialFilter = searchParams.get("status") || "pending";

  const [usersList, setUsersList] = useState([]);
  const [statusFilter, setStatusFilter] = useState(initialFilter);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [processingId, setProcessingId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    total: 0,
    from: 0,
    to: 0,
  });

  useEffect(() => {
    if (user && user.role !== "admin") {
      navigate("/");
      return;
    }
    fetchAccounts(statusFilter, currentPage, search);
  }, [user, statusFilter, currentPage]);

  const fetchAccounts = (filter, page = 1, searchVal = search) => {
    setLoading(true);
    fetch(`/api/admin/pending-accounts?page=${page}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ status: filter, page, search: searchVal }),
    })
      .then((res) => res.json())
      .then((resData) => {
        setLoading(false);
        if (resData.data?.data) {
          setUsersList(resData.data.data);
          setPagination({
            current_page: resData.data.current_page,
            last_page: resData.data.last_page,
            total: resData.data.total,
            from: resData.data.from,
            to: resData.data.to,
          });
        } else if (Array.isArray(resData.data)) {
          setUsersList(resData.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching accounts:", err);
        setLoading(false);
      });
  };

  const handleFilterChange = (newFilter) => {
    setStatusFilter(newFilter);
    setCurrentPage(1);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    fetchAccounts(statusFilter, 1, search);
  };

  const handleUpdateStatus = (targetUserId, newStatus) => {
    setProcessingId(targetUserId);
    fetch("/api/admin/update-user-status", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ user_id: targetUserId, status: newStatus }),
    })
      .then((res) => res.json())
      .then((data) => {
        setProcessingId(null);
        if (data.message) {
          fetchAccounts(statusFilter, currentPage, search);
        } else if (data.error) {
          alert(data.error);
        }
      })
      .catch((err) => {
        console.error(err);
        setProcessingId(null);
      });
  };

  return (
    <div>
      <Header />
      <Leftmenu />
      <div className="main-content bg-lightblue theme-dark-bg admin-main-page" style={{ minHeight: "100vh" }}>
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left w-100" style={{ maxWidth: "100%", margin: 0, paddingRight: 0 }}>
            <div className="admin-wrap-full w-100" style={{ maxWidth: "100%", margin: 0 }}>
              {/* Top Banner */}
              <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4 rounded-xxl overflow-hidden">
                <div className="card-body p-4 w-100 bg-current border-0 d-flex align-items-center justify-content-between rounded-3">
                  <div className="d-flex align-items-center">
                    <Link to="/admin/dashboard" className="text-white me-3">
                      <i className="feather-arrow-left font-sm"></i>
                    </Link>
                    <div>
                      <h4 className="font-xs text-white fw-600 mb-0">Pending Account Approvals</h4>
                      <span className="font-xssss text-white opacity-75">Review and verify student & faculty accounts (Completed profiles only)</span>
                    </div>
                  </div>
                  <Link to="/admin/dashboard" className="btn btn-sm btn-light font-xssss fw-600 px-3 py-1 rounded-pill">
                    &larr; Dashboard
                  </Link>
                </div>
              </div>

              {/* Status Filter and Search Bar */}
              <div className="card shadow-xss border-0 p-3 rounded-xxl bg-white mb-4">
                <div className="row g-2 align-items-center justify-content-between">
                  <div className="col-lg-7">
                    <div className="d-flex flex-wrap gap-2">
                      <button
                        type="button"
                        className={`btn btn-sm font-xssss fw-600 px-3 py-2 rounded-xl ${
                          statusFilter === "pending" ? "btn-warning text-dark" : "btn-light text-grey-700"
                        }`}
                        onClick={() => handleFilterChange("pending")}
                      >
                        Pending Approval
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm font-xssss fw-600 px-3 py-2 rounded-xl ${
                          statusFilter === "incomplete" ? "btn-secondary text-white" : "btn-light text-grey-700"
                        }`}
                        onClick={() => handleFilterChange("incomplete")}
                      >
                        Incomplete Profiles
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm font-xssss fw-600 px-3 py-2 rounded-xl ${
                          statusFilter === "approved" ? "btn-success text-white" : "btn-light text-grey-700"
                        }`}
                        onClick={() => handleFilterChange("approved")}
                      >
                        Approved Accounts
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm font-xssss fw-600 px-3 py-2 rounded-xl ${
                          statusFilter === "rejected" ? "btn-danger text-white" : "btn-light text-grey-700"
                        }`}
                        onClick={() => handleFilterChange("rejected")}
                      >
                        Rejected
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm font-xssss fw-600 px-3 py-2 rounded-xl ${
                          statusFilter === "all" ? "btn-dark text-white" : "btn-light text-grey-700"
                        }`}
                        onClick={() => handleFilterChange("all")}
                      >
                        All Users
                      </button>
                    </div>
                  </div>
                  <div className="col-lg-5">
                    <form onSubmit={handleSearchSubmit} className="d-flex gap-2">
                      <input
                        type="text"
                        placeholder="Search name, email, phone..."
                        className="form-control font-xssss border-light-md rounded-xl"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                      <button type="submit" className="btn bg-current text-white font-xssss fw-600 px-3 rounded-xl">
                        Search
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-secondary font-xssss fw-600 px-2 rounded-xl"
                        onClick={() => { setSearch(""); fetchAccounts(statusFilter, currentPage, ""); }}
                        title="Refresh"
                      >
                        <i className="feather-refresh-cw"></i>
                      </button>
                    </form>
                  </div>
                </div>
              </div>

              {/* Accounts Table Card */}
              <div className="card shadow-xss border-0 p-4 rounded-xxl bg-white mb-4">
                {loading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-danger" role="status"></div>
                    <p className="mt-3 text-grey-600 font-xsss mb-0">Loading accounts...</p>
                  </div>
                ) : usersList.length > 0 ? (
                  <>
                    <div className="table-responsive">
                      <table className="table align-middle table-hover mb-0 font-xssss">
                        <thead className="bg-light">
                          <tr>
                            <th className="py-3 ps-3">User Details</th>
                            <th className="py-3">Role</th>
                            <th className="py-3">Education / Details</th>
                            <th className="py-3">Status</th>
                            <th className="py-3">Registered</th>
                            <th className="py-3 text-end pe-3">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {usersList.map((target) => (
                            <tr key={target.id}>
                              <td className="ps-3 py-3">
                                <h5 className="font-xsss fw-700 text-grey-900 mb-0">{target.name}</h5>
                                <span className="font-xssss text-grey-600 d-block">{target.email}</span>
                                {target.phone && (
                                  <small className="font-xsssss text-grey-500">{target.phone}</small>
                                )}
                              </td>
                              <td>
                                <span
                                  className={`badge font-xsssss text-uppercase px-2 py-1 rounded-pill ${
                                    target.role === "admin"
                                      ? "bg-danger text-white"
                                      : target.role === "faculty"
                                      ? "bg-primary text-white"
                                      : "bg-light text-dark border"
                                  }`}
                                >
                                  {target.role || "student"}
                                </span>
                              </td>
                              <td>
                                {target.academic_details?.graduation_degree ? (
                                  <div>
                                    <span className="fw-600 text-grey-800 d-block">
                                      {target.academic_details.graduation_degree}
                                      {target.academic_details.graduation_course && ` (${target.academic_details.graduation_course})`}
                                    </span>
                                    {target.academic_details.graduation_end_year && (
                                      <small className="text-grey-500 font-xsssss">
                                        Class of {target.academic_details.graduation_end_year}
                                      </small>
                                    )}
                                  </div>
                                ) : (
                                  <span className="text-grey-400 font-xsssss">No academic info</span>
                                )}
                              </td>
                              <td>
                                <span
                                  className={`badge font-xsssss text-uppercase px-2 py-1 rounded-pill ${
                                    target.status === "approved"
                                      ? "bg-success text-white"
                                      : target.status === "rejected"
                                      ? "bg-danger text-white"
                                      : target.status === "inactive"
                                      ? "bg-secondary text-white"
                                      : "bg-warning text-dark"
                                  }`}
                                >
                                  {target.status}
                                </span>
                                {target.profile_status && (
                                  <span
                                    className={`badge font-xsssss text-uppercase px-2 py-1 rounded-pill d-block mt-1 ${
                                      target.profile_status === "complete"
                                        ? "bg-success text-white"
                                        : "bg-secondary text-white"
                                    }`}
                                    style={{ width: "fit-content" }}
                                  >
                                    {target.profile_status === "complete" ? "✓ Profile Complete" : `Profile: ${target.profile_status}`}
                                  </span>
                                )}
                              </td>
                              <td className="text-grey-500 font-xsssss">
                                {moment(target.created_at).format("MMM D, YYYY")}
                                <br />
                                <small className="text-grey-400">{moment(target.created_at).fromNow()}</small>
                              </td>
                              <td className="text-end pe-3">
                                <div className="d-flex justify-content-end gap-1">
                                  {target.status !== "approved" && (
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-success font-xsssss fw-600 px-3 py-1 rounded-2"
                                      disabled={processingId === target.id}
                                      onClick={() => handleUpdateStatus(target.id, "approved")}
                                    >
                                      Approve
                                    </button>
                                  )}
                                  {/* Delete/Reject option removed for pending accounts as requested */}
                                  {target.status !== "pending" && target.status !== "rejected" && (
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-danger font-xsssss fw-600 px-3 py-1 rounded-2"
                                      disabled={processingId === target.id}
                                      onClick={() => handleUpdateStatus(target.id, "rejected")}
                                    >
                                      Reject
                                    </button>
                                  )}
                                  {target.status === "approved" && (
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-secondary font-xsssss fw-600 px-2 py-1 rounded-2"
                                      disabled={processingId === target.id}
                                      onClick={() => handleUpdateStatus(target.id, "inactive")}
                                      title="Deactivate account"
                                    >
                                      Suspend
                                    </button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination */}
                    <Pagination
                      currentPage={pagination.current_page}
                      lastPage={pagination.last_page}
                      total={pagination.total}
                      from={pagination.from}
                      to={pagination.to}
                      onPageChange={(p) => setCurrentPage(p)}
                      itemName="accounts"
                    />
                  </>
                ) : (
                  <div className="text-center py-5">
                    <i className="feather-check-circle font-xxl text-success mb-2 d-block"></i>
                    <h5 className="fw-700 font-xs text-grey-800 mb-1">No Accounts Found</h5>
                    <p className="text-grey-500 font-xssss mb-0">
                      There are no {statusFilter === "pending" ? "pending accounts with completed profiles" : `${statusFilter} accounts`} matching your filter.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminPendingAccounts;
